import DataTable from "@standard/components/DataTable";
import { UserRoleData } from "data";
import { UserRole } from "data/userRole";

const url = "master/user";
const columns = [
  {
    label: "Email",
    name: "email",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Name",
    name: "name",
    sortable: true,
    search: { type: "text" },
  },
  {
    label: "Roles",
    name: "roles",
    sortable: true,
    align: "center",
    search: { type: "checkbox", inline: true, datasource: UserRoleData },
  },
];

const config = {
  enableActive: false,
  enableEdit: true,
  enableTrash: false,
  enableInsert: false,
  enableView: true,
  onBeforeBind: (data) => {
    return data.map((item) => {
      const { roles } = item.values;

      item.values.roles = roles.map((role) => (
        <UserRole key={role} value={role} />
      ));

      return item;
    });
  },
};

export default function UserTable() {
  return <DataTable columns={columns} url={url} {...config} />;
}
